import type { ReactNode } from 'react';

import { cn } from '@/design-system/lib/cn';
import { LEGAL_DOC_LABEL, type LegalDocKey } from '@escala/domain/legal';

import { useLegal } from './context';

/**
 * Link no meio do texto ("…com os Termos de Uso e a Política de Privacidade") que abre o
 * documento por cima da tela — sem sair do formulário. Herda o tamanho do texto.
 */
export default function LegalLink({
  doc,
  orgName,
  children,
  className,
}: {
  doc: LegalDocKey;
  orgName?: string;
  children?: ReactNode;
  className?: string;
}) {
  const { openLegal } = useLegal();

  return (
    <button
      type="button"
      onClick={(e) => {
        // Dentro de um <label> ou de uma caixa de seleção, o clique não marca nada.
        e.preventDefault();
        e.stopPropagation();
        openLegal(doc, { orgName });
      }}
      className={cn(
        'cursor-pointer border-0 bg-transparent p-0 font-semibold text-primary hover:text-primary-hover hover:underline',
        className
      )}
    >
      {children ?? LEGAL_DOC_LABEL[doc].title}
    </button>
  );
}
